export var ChatChannel;
(function (ChatChannel) {
    ChatChannel[ChatChannel["Local"] = 0] = "Local";
    ChatChannel[ChatChannel["Sector"] = 1] = "Sector";
    ChatChannel[ChatChannel["Fleet"] = 2] = "Fleet";
    ChatChannel[ChatChannel["Direct"] = 3] = "Direct";
    ChatChannel[ChatChannel["System"] = 4] = "System";
    ChatChannel[ChatChannel["Global"] = 5] = "Global";
})(ChatChannel || (ChatChannel = {}));
export var LeaderboardType;
(function (LeaderboardType) {
    LeaderboardType[LeaderboardType["XP"] = 0] = "XP";
    LeaderboardType[LeaderboardType["Kills"] = 1] = "Kills";
    LeaderboardType[LeaderboardType["ResourcesMined"] = 2] = "ResourcesMined";
    LeaderboardType[LeaderboardType["SectorsDiscovered"] = 3] = "SectorsDiscovered";
    LeaderboardType[LeaderboardType["Credits"] = 4] = "Credits";
    LeaderboardType[LeaderboardType["MissionsCompleted"] = 5] = "MissionsCompleted";
})(LeaderboardType || (LeaderboardType = {}));
//# sourceMappingURL=social.js.map